/**
 * Unique symbol used to store property interceptors.
 * 
 * @type {unique symbol}
 */
export const PROPERTY_INTERCEPTOR_SYMBOL: unique symbol = Symbol.for('$DSPropertyInterceptor');
